module.exports = __webpack_public_path__ + "static/media/Iris Street, San Francisco, CA6.c1de82dd.jpg";